export const metadataSpecializationOptions = [
  {
    label: 'Неврология',
    value: 'neurology',
  },
  {
    label: 'Онкология',
    value: 'oncology',
  },
  {
    label: 'Клинична лаборатория',
    value: 'clinical_laboratory',
  },
  {
    label: 'Микробиология',
    value: 'microbiology',
  },
  {
    label: 'Стоматология',
    value: 'dentistry',
  },
  {
    label: 'Ендокринология',
    value: 'endocrinology',
  },
  {
    label: 'Образна диагностика',
    value: 'image_diagnostics',
  },
  {
    label: 'Анестезиология',
    value: 'anesthesiology',
  },
  {
    label: 'Паразитология',
    value: 'parasitology',
  },
  {
    label: 'Акушерство и гинекология',
    value: 'obstetrics_gynecology',
  },
  {
    label: 'Кардиология',
    value: 'cardiology',
  },
  {
    label: 'Дерматология',
    value: 'dermatology',
  },
  {
    label: 'Хирургия',
    value: 'surgery',
  },
  {
    label: 'Ортопедия',
    value: 'orthopedics',
  },
  {
    label: 'Офталмология',
    value: 'ophthalmology',
  },
  {
    label: 'Зоопсихология',
    value: 'zoo_psychology',
  },
  {
    label: 'Екзотични животни',
    value: 'exotic_animals',
  },
  {
    label: 'Общопрактикуващ',
    value: 'general_practitioner',
  },
  {
    label: 'Коремна хирургия',
    value: 'abdominal_surgery'
  },
  {
    label: 'Гръдна хирургия',
    value: 'thoracic_surgery'
  },
  {
    label: 'Патоанатомия',
    value: 'pathology'
  },
  {
    label: 'Хематология',
    value: 'haematology'
  },
  {
    label: 'Алергология',
    value: 'allergology'
  },
  {
    label: 'Нефрология',
    value: 'nephrology'
  },
  {
    label: 'Инфекциозни болести',
    value: 'infectious_diseases'
  },
  {
    label: 'Ревматология',
    value: 'rheumatology'
  },
  {
    label: 'Болести по рибите',
    value: 'fish_diseases'
  },
  {
    label: 'Заболявания по птиците',
    value: 'bird_diseases'
  },
  {
    label: 'Болести по селскостопанските животни',
    value: 'livestock_diseases'
  },
  {
    label: 'Болести по животни за компания',
    value: 'companion_animal_diseases'
  },
  {
    label: 'Клинична фармакология',
    value: 'clinical_pharmacology'
  },
  {
    label: 'Спешна медицина',
    value: 'emergency_medicine'
  },
  {
    label: 'Заболявания по пчелите',
    value: 'bee_diseases'
  },
  {
    label: 'Имунология',
    value: 'immunology'
  },
  {
    label: 'Вътрешни болести',
    value: 'internal_diseases'
  },
  {
    label: 'Неврология и неврохирургия',
    value: 'neurology_and_neurosurgery'
  },
  {
    label: 'Хранене',
    value: 'nutrition'
  },
  {
    label: 'Лъчелечение',
    value: 'radiotherapy'
  },
  {
    label: 'Заболявания по влечугите',
    value: 'reptile_diseases'
  },
  {
    label: 'Спортна медицина и рехабилитация',
    value: 'sports_medicine_and_rehabilitation'
  },
  {
    label: 'Токсикология',
    value: 'toxicology'
  },
  {
    label: 'Болести по конете',
    value: 'horse_diseases'
  }

]
